import { api } from '~/requests/api';

export const QK_CONTACT_US = 'qk_contactUs';

export interface IContactUsRequest {
  email: string;
  message: string;
  fullName: string;
  phoneNumber: string;
}

function contactUs(payload: IContactUsRequest) {
  return api.post('/contacts', {
    contact: {
      ...payload,
    },
  });
}

export const contactApi = {
  contactUs,
} as const;
